import React, { FC } from 'react';

import {
  CurrentUserDraftAndPendingIdeasQuery,
  useDestroyIdeaDraftMutation
} from 'interfaces/graphql-typings';

import styles from './userIdeasPageStyles.scss';

const DeleteDraftIdeaButton: FC<{ ideaId: string }> = ({ ideaId }) => {
  const [destroyIdeaDraft, { loading }] = useDestroyIdeaDraftMutation({
    update: (cache, { data }) => {
      if (!data?.destroyIdeaDraft) return;

      cache.modify({
        id: cache.identify({
          id: data.destroyIdeaDraft.currentUserId,
          __typename: 'User'
        }),
        fields: {
          draftIdeas: (cachedIdeas, { readField }) =>
            cachedIdeas.filter(
              (
                idea: NonNullable<
                  NonNullable<
                    CurrentUserDraftAndPendingIdeasQuery['currentUser']
                  >['draftAndPendingIdeas']
                >[number]
              ) => data.destroyIdeaDraft?.ideaId !== readField('id', idea)
            )
        }
      });
    }
  });

  return (
    <button
      disabled={loading}
      onClick={() => destroyIdeaDraft({ variables: { ideaId } })}
      className={styles.deleteButton}
    >
      x Delete Draft
    </button>
  );
};

export default DeleteDraftIdeaButton;
